"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELDS_METADATA_KEY = 'serialize:fields';
/**
 * Key for reflect-metadata that stores name of json that should be saved
 * This are internal field keys that can be changed!
 */
exports.__FIELD_JSON_NAME_METADATA_KEY = 'serialize:field:json-property-name';
// export const __FIELD_MODEL_NAME_METADATA_KEY = "serialize:field:model-property-name";
exports.__FIELD_SERIALIZER_METADATA_KEY = 'serialize:field:serialize';
exports.__FIELD_CLASS_FIELDS_METADATA_KEY = 'serialize:class:fields';
